import Link from "next/link";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IProduct } from "../../model/product";
import styles from './similar-products.module.css';
export default function SimilarProducts({products}: {products: IProduct[]}) {
	return (
		<div style={{textAlign: 'left'}}>
			<h4 className={styles.cstmH4}>Andre produkter du kanskje liker</h4>
			<div className={styles.container}>
				{products.map((p: IProduct, index: number) => {
					return (
					<Link href={`/produkter/${p.brand}/${p.urlName}`} onClick={() => {window.location.href= `/produkter/${p.brand}/${p.urlName}`}} replace={true} passHref key={`similar_${index}`}>
					<div className={styles.card}>
						<LazyLoadImage className={styles.image} src={p.image} alt={p.name} /><br/>
						<div className={styles.title}>{p.name}</div>
					</div></Link>)
				})}
			</div>
		</div>
	)
}